export class Company {
   constructor({
      id = null,
      companyName = null,
      filingDeadlineMonth = null,
      filingDeadlineDay = null,
      fein = null,
      entityType = null,
      taxYearEndMonth = null,
      taxYearEndDay = null,
      industryId = null,
      stateCredits = [],
      payrollTaxElection = false,
      incorporated = null,
      firstRndEffort = null,
      startupYear = null,
      businessManagers = [],
      projectManagers = [],
      projectAssociates = [],
      externalPartners = [],
      cpaInfo = {name: null, firm: null, email: null},
      contactInfo = {name: null, email: null},
      prompts = {supplies: null, uploads: null},
      studies = [],
      openStudies = [],
      created = null,
      projectTeamMembers = [],
      studyTeamMembers = [],
      detail = false,
   } = {}) {
      const formatDate = (date) => {
         if (date && typeof date === 'string') {
            let [year, month, day] = date.split('-');
            month = +month - 1; // convert to 0-based index
            return new Date(year, month, day);
         }
         return date;
      };

      this.id = id;
      this.companyName = companyName;
      this.filingDeadlineMonth = filingDeadlineMonth;
      this.filingDeadlineDay = filingDeadlineDay;
      this._fein = fein;
      this.entityType = entityType;
      this.taxYearEndMonth = taxYearEndMonth;
      this.taxYearEndDay = taxYearEndDay;
      this.industryId = industryId;
      this.stateCredits = stateCredits.map((state) => state.toUpperCase());
      this.payrollTaxElection = payrollTaxElection;
      this.incorporated = formatDate(incorporated);
      this.firstRndEffort = firstRndEffort;
      this.startupYear = {
         lower: startupYear?.lower ?? null,
         upper: startupYear?.upper ?? null,
      };
      this.businessManagers = businessManagers;
      this.projectManagers = projectManagers;
      this.projectAssociates = projectAssociates;
      this.externalPartners = externalPartners;
      this.cpaInfo = cpaInfo;
      this.contactInfo = contactInfo;
      this.prompts = prompts;
      this.studies = studies;
      this.openStudies = openStudies;
      this.created = created;
      this.projectTeamMembers = projectTeamMembers;
      this.studyTeamMembers = studyTeamMembers;
      this.detail = detail;
   }

   get fein() {
      return this._fein ? `${this._fein.substring(0, 2)}-${this._fein.substring(2)}` : null;
   }
   set fein(val) {
      if (val) {
         this._fein = val.replace(/-/g, '');
      } else {
         this._fein = null;
      }
   }

   addState() {
      this.stateCredits.push(null);
   }

   deleteState(index) {
      this.stateCredits.splice(index, 1);
   }

   export() {
      const exportDate = (date) => {
         if (!date) {
            return null;
         }
         // convert to UTC so we can use toISOString without potentially rolling over a day
         const offset = date.getTimezoneOffset() * 60 * 1000; // minutes -> milliseconds
         const utcDate = new Date(date.getTime() - offset);
         return utcDate.toISOString().split('T')[0];
      };

      return {
         companyName: this.companyName,
         filingDeadlineMonth: this.filingDeadlineMonth,
         filingDeadlineDay: this.filingDeadlineDay,
         fein: this._fein,
         entityType: this.entityType,
         taxYearEndMonth: this.taxYearEndMonth,
         taxYearEndDay: this.taxYearEndDay,
         industryId: this.industryId,
         stateCredits: this.stateCredits.filter((state) => state !== null),
         payrollTaxElection: this.payrollTaxElection,
         incorporated: exportDate(this.incorporated),
         firstRndEffort: this.firstRndEffort,
         startupYear: this.startupYear.lower && this.startupYear.upper ? this.startupYear : null,
         cpaInfo: this.cpaInfo,
         contactInfo: this.contactInfo,
         prompts: this.prompts,
         stage: this.stage,
         stageCompletion: this.stageCompletion,
         studies: this.studies,
         openStudies: this.openStudies,
         projectTeamMembers: this.projectTeamMembers,
         studyTeamMembers: this.studyTeamMembers,
      };
   }
}
